var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      attrs: {
        "bg-variant": "white",
        right: "",
        backdrop: "",
        width: "40vw",
        shadow: true,
        visible: _vm.show
      },
      on: { change: _vm.onChangeSidebar }
    },
    [
      !_vm.config.usingForm
        ? _c("ActivitySidebarHeader", { attrs: { activity: _vm.activity } })
        : _vm._e(),
      !_vm.config.usingForm
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED068" } },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "custom-control-warning float-right mb-2",
                          attrs: { name: "check-button", switch: "" },
                          model: {
                            value: _vm.editMode,
                            callback: function($$v) {
                              _vm.editMode = $$v
                            },
                            expression: "editMode"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "switch-icon-left" },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "ActivityIcon" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "switch-icon-right" },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "CodeIcon" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.editMode || _vm.usingForm
        ? _c("ActivityForm", {
            attrs: {
              "selected-activity": _vm.activity,
              column: _vm.config.column,
              "kanban-id": _vm.kanbanId,
              "reference-id": _vm.referenceId,
              "reference-type": _vm.referenceType,
              "reference-number": _vm.referenceNumber,
              "edit-mode": _vm.editMode,
              "on-updated": function() {
                return (this$1.editMode = false)
              }
            }
          })
        : _vm.activityId
        ? _c("ActivityDetail", { attrs: { activity: _vm.activity } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }